<template>
  <div class="wrapper">
    <div class="actions d-flex flex-row align-center pr-2 pl-2">
      <ul class="actions-wrapper">
        <li class="action-items table-search ma-2">
          <v-text-field
            v-model="searchString"
            class="searchbar"
            hide-details
            dense
            clearable
            solo
            label="Search by Project"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </li>
      </ul>
    </div>
    <div class="table">
      <data-table
        :index="true"
        :dense="true"
        :multiSelect="false"
        :fixedHeader="false"
        height="auto"
        :headers="headers"
        :content="expenseData"
        :isCheckable="false"
        :searchString="searchString"
        @image="displayImages"
        @delete="deleteItem"
      ></data-table>
    </div>
    <v-dialog v-model="displayImageDialog" max-height="75vh" max-width="75vw">
      <v-card>
        <div id="mdiv" @click="displayImageDialog = false">
          <div class="mdiv">
            <div class="md"></div>
          </div>
        </div>
        <v-card-text class="displayImage">
          <v-img
            :src="displayImage.imageUrl"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          >
            <v-card-title v-text="displayImage.imageName"></v-card-title>
          </v-img>
        </v-card-text>
        <v-card-actions>
          <v-card-title v-text="displayImage.imageName"></v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            outlined
            @click="displayImageDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "../firebase";
import DataTable from "../components/DataTable.vue";

export default {
  name: "Expense",
  components: {
    DataTable
  },
  data() {
    return {
      displayImageDialog: false,
      displayImage: "",
      searchString: "",
      expenseData: [],
      headers: [
        {
          name: "imageObject",
          label: "Image",
          type: "avatar"
        },
        {
          name: "id",
          label: "Expense ID",
          type: "text"
        },
        {
          name: "title",
          label: "Expense Title",
          type: "text"
        },
        {
          name: "amount",
          label: "Amount",
          type: "text"
        },
        {
          name: "employeeName",
          label: "Employee Name",
          type: "text"
        },
        {
          name: "date",
          label: "Date",
          type: "date"
        },
        {
          name: "projectName",
          label: "Project Name",
          type: "text"
        },
        {
          name: "customer",
          label: "Customer",
          type: "text"
        },
        {
          label: "Action",
          type: "action",
          actions: [
            {
              label: "Image",
              value: "image"
            },
            {
              label: "Delete",
              value: "delete"
            }
          ]
        }
      ]
    };
  },
  created() {
    let self = this;
    let projectsRef = firebase.firestore().collection("projects");
    projectsRef.onSnapshot((querySnapshot) => {
      self.expenseData = [];
      querySnapshot.docs.forEach((doc) => {
        let projectId = JSON.parse(JSON.stringify(doc.id));
        doc.ref.collection("Employees").onSnapshot((empQuerySnapshot) => {
          empQuerySnapshot.docs.forEach((empDoc) => {
            let empId = JSON.parse(JSON.stringify(empDoc.id));
            empDoc.ref
              .collection("expenses")
              .onSnapshot((expenseQuerySnapShot) => {
                let empData = JSON.parse(JSON.stringify(empDoc.data()));
                let expenseDoc = expenseQuerySnapShot.docs.slice(0);
                if (expenseDoc.length > 0) {
                  for (let index = 0; index < expenseDoc.length; index++) {
                    const data = expenseDoc[index].data();
                    self.expenseData = self.expenseData.filter(
                      (obj) => obj.id != data.id
                    );
                    self.expenseData.push({
                      customer: empData.customer,
                      employeeId: empId,
                      employeeName: empData.employeeName,
                      projectId: projectId,
                      projectName: empData.projectName,
                      amount: data.amount,
                      date: data.date,
                      id: data.id,
                      title: data.title,
                      imageObject: data.imageObject
                    });
                  }
                }
              });
          });
        });
      });
    });
  },
  methods: {
    displayImages(image) {
      if (image && image.imageUrl) {
        this.displayImage = image;
        this.displayImageDialog = true;
      }
    },
    deleteItem(item) {
      let self = this;
      firebase
        .firestore()
        .collection("projects")
        .doc(item.projectId)
        .collection("Employees")
        .doc(item.employeeId)
        .collection("expenses")
        .doc(item.id)
        .delete()
        .then(function() {
          self.expenseData = self.expenseData.filter(
            (obj) => obj.id != item.id
          );
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });
    }
  }
};
</script>

<style scoped>
.actions-wrapper {
  width: 100%;
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px;
  padding: 0px;
  flex-wrap: wrap;
}

.table-search {
  width: 100%;
  min-width: 200px;
  max-width: 600px;
}

.v-input--selection-controls {
  margin-top: 0px;
}

#mdiv {
  width: 25px;
  height: 25px;
  float: right;
}

.mdiv {
  height: 25px;
  width: 2px;
  margin-left: 12px;
  background-color: grey;
  transform: rotate(45deg);
  z-index: 1;
}

.md {
  height: 25px;
  width: 2px;
  background-color: grey;
  transform: rotate(90deg);
  z-index: 2;
  cursor: pointer;
}

.displayImage {
  width: 98%;
  height: 70vh;
  overflow: auto;
  padding: 20px;
  margin: 20px;
  box-sizing: border-box;
}
</style>
